import cx from 'classnames';

type GroupProps = {
  border?: boolean;
  children: React.ReactNode | React.ReactNode[];
  className?: string;
};

const Group = ({
  border = false,
  children,
  className,
  ...props
}: GroupProps): React.ReactNode => (
  <section
    className={cx('w-full px-4 py-1', className, {
      'border-t-thin border-solid border-black/12': border
    })}
    {...props}
  >
    {children}
  </section>
);

export default Group;
